<template>
  <div>
    <el-steps :active="step" align-center>
      <el-step title="题干" description="题干可以是文字、图片、语音"></el-step>
      <el-step title="选项" description="选项可以是单选、多选、文本跟读、字词选择、字词组合"></el-step>
      <el-step title="正确答案" description="答案可以是选项序号、文本、语音录入、字词组合"></el-step>
      <el-step title="其他设置" description="设置题目标签、题型"></el-step>
    </el-steps>
    <el-form :model="question" :rules="rules" ref="question" label-width="100px;" style="padding:60px;">
      <el-row v-if="step==0 || step ==1 ">
        <el-col :span="12" style="padding-right: 140px;">
          <el-form-item v-for="(data, index) in tempData[step]">
            <div style="word-wrap: break-word;" v-bind:style="{ color: index==currentIndex?'#20a0ff':'black' }">
              {{data.sn}} . {{data.intro}}
            </div>
            <div> <img style="max-width: 70%;
    height: auto;" v-bind:src=" data.image.url" /></div>
            <div>
              <audio v-if="data.voice" :src="data.voice.url" controls="controls">
              </audio>
            </div>
            <el-button @click.prevent="editTemp(index)">编辑</el-button>
            <el-button v-if="index>0" @click.prevent="deleteTemp(index)">删除</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="border-left:1px solid #20a0ff;padding:30px;padding-right:100px;padding-left:100px;">
            <!--    <el-form-item style="margin-top: 10px;text-align: right;">
                                <el-button @click.prevent="deleteTemp(index)">删除该项</el-button>
                            </el-form-item> -->
            <el-tabs :tab-position="tabPosition" style="">
              <el-tab-pane label="文字">
                <el-input type="textarea" :rows="6" v-model="tempData[step][currentIndex].intro"></el-input>
              </el-tab-pane>
              <el-tab-pane label="图片">
                <el-upload accept="image/*" :limit=1 :http-request="uploadImage" action="" :on-remove="removeImage" list-type="picture-card" :file-list="currentImages">
                  <el-button type="primary">上传图片(一张)</el-button>
                </el-upload>
              </el-tab-pane>
              <el-tab-pane label="语音">
                <el-upload :limit=1 accept="audio/mp3" :http-request="uploadVoice" action="" :on-remove="removeVoice" list-type="picture-card" :file-list="currentVoices">
                  <el-button type="primary">上传语音(一条)</el-button>
                </el-upload>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
         <el-form-item style="margin-top: 50px;text-align: right;">
           <el-button type="primary" @click.prevent="saveTemp()">仅保存</el-button>
           <el-button type="success" @click.prevent="addTemp()">保存并新增</el-button>
           <el-button v-if="step>0" @click="preStep">上一步</el-button>
           <el-button v-if="step<3" type="warning" @click="nextStep">下一步</el-button>
         </el-form-item>
        </el-col>

      </el-row>
      <el-row v-if="step==2">
        <!-- 答案区域 -->
        <el-radio-group v-model="answerType">
          <el-radio :label=0>选择题</el-radio>
          <el-radio :label=1>描述题</el-radio>
          <el-radio :label=2>朗读体(需要语音录入)</el-radio>
          <el-radio :label=3>顺序拼接题(单词填空)</el-radio>
        </el-radio-group>
        <div style="margin-top: 50px;margin-bottom: 50px;">
          <el-table v-if="answerType == 0" highlight-current-row ref="multipleTable" :data="tempData[1]" style="width: 100%" @selection-change="handleMultipleChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column property="sn" label="序号" width="120">
            </el-table-column>
            <el-table-column property="intro" label="文本" width="200">
            </el-table-column>
            <el-table-column property="image" label="图片">
              <template slot-scope="scope">
                <img v-if="scope.row.image" style="width: 50px;height:50px;" :src=" scope.row.image.url" />
              </template>
            </el-table-column>
            <el-table-column property="voice" label="语音">
              <template slot-scope="scope">
                <audio v-if="scope.row.voice" :src="scope.row.voice.url" controls="controls">
                </audio>
              </template>
            </el-table-column>
          </el-table>
          <div v-else-if="answerType == 1">
            <el-input type="textarea" v-model="standardAnswerText" :rows="6" placeholder="请输入标准答案文本(若无则不填)"></el-input>
          </div>
          <div v-else-if="answerType == 2">
            <el-input type="textarea" v-model="standardAnswerText" :rows="6" placeholder="请输入标准答案文本(多个答案，以'|'隔开)"></el-input>
          </div>
          <div v-else-if="answerType == 3">
				 <el-input type="textarea" v-model="standardAnswerText" :rows="6" placeholder="请输入标准答案文本(此处按顺序输入填空的单词,以'|'隔开)"></el-input>
          </div>
        </div>
        <el-form-item style="margin-top: 50px;text-align: right;">
          <el-button v-if="step>0" @click="preStep">上一步</el-button>
          <el-button v-if="step<3" type="warning" @click="nextStep">下一步</el-button>
        </el-form-item>
      </el-row>
      <el-row v-if="step==3">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="标签" name="1">
            <el-form-item>
              <el-select style="margin-left: 10px;width:80%;" multiple v-model="tagsValue" placeholder="请选择" @change="changeselect">
                <el-option v-for="item in tags" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="年级" name="2">
            <el-form-item>
              <el-select style="margin-left: 10px;"  v-model="gradesValue" placeholder="请选择" width="1000">
                <el-option v-for="item in grades" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
         <!-- <el-collapse-item title="天数" name="2">
            <el-form-item>

              <el-input-number v-model.number="anyDay" style="width:200px;" placeholder="请输入"  max=100></el-input-number>

            </el-form-item>
          </el-collapse-item> -->
          <el-collapse-item title="单元" name="3">
            <el-form-item>
              <el-select style="margin-left: 10px;" v-model="gradeClassify" placeholder="请选择" width="500">
                <el-option v-for="item in gradeClassifies" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="题型" name="4">
            <el-select style="margin-left: 10px;" v-model="questionTypesValue" placeholder="请选择" width="500">
              <el-option v-for="item in questionTypes" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-collapse-item>
      <!--    <el-collapse-item title="第几道题" name="5">
            <el-form-item>

              <el-input-number v-model.number="indexInOneDay" placeholder="请输入" style="width:200px;"  max=100></el-input-number>


            </el-form-item>
          </el-collapse-item> -->
          <div class="block" style="float: right;">
            <el-form-item style="margin-top: 50px;text-align: right;">
              <el-button v-if="step>0" @click="preStep">上一步</el-button>
              <el-button type="success" @click="submitForm('question')">保存本题</el-button>
            </el-form-item>
          </div>
        </el-collapse>
      </el-row>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center>
      <span>保存成功,是否继续新建题目?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toQuestionList">进入题目列表</el-button>
        <el-button type="primary" @click="continueAddQuestion">继续新增</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AV from 'leancloud-storage'
import Question from '../../model/question'
import QuestionType from '../../model/questionType'
import AnswerType from '../../model/answerType'
import Grade from '../../model/grade'
import Tag from '../../model/tag'
import { setTimeout } from 'timers'
export default {
  inject: ['reload'],
  data() {
    return {
      tabPosition: 'top',
      step: 0,
      currentIndex: 0,
      currentImages: [],
      currentVoices: [],
      answerType: 0, //答案类型
      activeNames: ['1', '2', '3', '4', '5'],

      questionTypes: [],
      questionTypesAV: [],
      grades: [],
      gradesAV: [],
      tagsAV:[],
      tags:[],
      questionTypesValue: '',
      gradesValue: '',
      gradeValue:'',
      tagsValue:'',

      questionTypeCount: 0,
      questionTypeCurrentPage: 1,
      gradeCount: 0,
      gradeCurrentPage: 1,
      pageSize: 3,
      gradeClassifies: [{
          value: '1',
          label: 'unit1'
        },{
          value: '2',
          label: 'unit2'
        },{
          value: '3',
          label: 'unit3'
        },{
          value: '4',
          label: 'unit4'
        },{
          value: '5',
          label: 'unit5'
        },{
          value: '6',
          label: 'unit6'
        },{
          value: '7',
          label: 'unit7'
        },{
          value: '8',
          label: 'unit8'
        }],

      gradeClassify: '',

      anyDay: 1,
      indexInOneDay: 1,
      anyDays: [],
      indexInOneDays: [],
      tempData: [
        [
          {
            sn: 1,
            intro: '',
            image: '',
            voice: ''
          }
        ],
        [
          {
            sn: 1,
            intro: '',
            image: '',
            voice: ''
          }
        ]
      ],

      answerSelection: [],

      standardAnswerText: '',



      question: {},


      rules: {},

      dialogVisible: false
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  watch: {
    $route(to, from) {
      this.getData()
    }
  },
  methods: {
    changeselect(e){
      console.log(e)
      console.log(this.tagsValue)
    },
    getData() {
      let id = this.$route.query.id

      for (let i = 0; i < 100; i++) {
        this.anyDays.push(i + 1)
        this.indexInOneDays.push(i + 1)
      }

      this.dealWithTypeAndGrade()

      if (id == undefined) {
        this.question = new Question({
          license: this.app.license,
          templateType: this.app.templateType,
          creator: AV.User.current()
        }).toJSON()

        // this.anyDay =parseInt(localStorage.addAnyDay)
        // this.indexInOneDay = parseInt(localStorage.addIndexInOneDay)
        // this.gradesValue = localStorage.addGradesValue
        // this.questionTypesValue = localStorage.addQuestionTypesValue

        // console.log(localStorage);

        // new AV.Query(Question)
        //   .include('questionType')
        //   .include('grade')
        //   .descending('updatedAt')
        //   .first()
        //   .then(question => {
        //     this.anyDay = question.anyDay
        //     this.indexInOneDay = question.indexInOneDay
        //     if (question.questionType != undefined) {
        //       this.questionTypesValue = question.questionType.id
        //     }
        //     if (question.grade != undefined) {
        //       this.gradesValue = question.grade.id
        //     }
        //   })
      } else {
        new AV.Query(Question)
          .include('questionType')
          .include('grade')
          .get(id)
          .then(question => {
            this.answerType = question.answerType
            this.answerSelection = question.answerSelection
            this.standardAnswerText = question.standardAnswerText
            //处理一下不是选择题时，此处选项为空的情况
            this.tempData = question.questionData
            if (question.questionData[1].length == 0) {
              this.tempData[1].push({
                sn: 1,
                intro: '',
                image: '',
                voice: ''
              })
            }

            // console.log(this.tempData[1][0].sn);

            this.question = question.toJSON()

            //判断是否是复用
            if (this.$route.query.copy == '1') {
              this.question.objectId = ''
            }
            this.editTemp(0)
            if (question.tags != undefined) {
              this.tagsValue = []
              console.log(question)
              for (let i=0;i<question.tags.length;i++){
                this.tagsValue.push(question.tags[i].id)
              }
            }
            if (question.gradeClassify != undefined) {
              this.gradeClassify = question.gradeClassify
            }
            if (question.questionType != undefined) {
              this.questionTypesValue = question.questionType.id
            }
            if (question.grade != undefined) {
              this.gradesValue = question.grade.id
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    limitMax () {
    // 要做长度判断
    if(Number.valueOf(this.anyDay)>100){
this.anyDay=100;
    }
    // if (this.$refs.order.value.length > 11) {
    //   this.$refs.order.value = this.$refs.order.value.slice(0, 18)
    //   this.order = this.$refs.order.value
    // }
 },

    dealWithTypeAndGrade() {
      let that = this

      new AV.Query(QuestionType)
        .ascending('series')
        .find()
        .then(questionTypes => {
          this.questionTypesAV = questionTypes

          for (let i = 0; i < questionTypes.length; i++) {
            this.questionTypes.push({
              id: questionTypes[i].id,
              name: questionTypes[i].name
            })
          }
        })
      new AV.Query(Tag)
        .ascending('series')
        .find()
        .then(tags => {
          this.tagsAV = tags

          for (let i = 0; i < tags.length; i++) {
            this.tags.push({
              id: tags[i].id,
              name: tags[i].series + ' - ' + tags[i].name + ' - ' + tags[i].classify
            })
          }
         console.log(this.tags)
        })
      new AV.Query(Grade)
         .ascending('createdAt')
        .find()
        .then(grades => {
          this.gradesAV = grades
          for (let i = 0; i < grades.length; i++) {
            this.grades.push({
              id: grades[i].id,
              name: grades[i].grade
            })
          }
        })
    },

    saveTemp() {
      let lastTemp = this.tempData[this.step][this.tempData[this.step].length - 1]
      if (lastTemp.intro.length == 0 && typeof lastTemp.image === 'string' && typeof lastTemp.voice === 'string') {
        this.$message.error('文字、图片、语音三者不能都为空')
        return
      }
    },
    addTemp() {
      //判断序号是否唯一,文字、图片、语音三者不能都为空

      let lastTemp = this.tempData[this.step][this.tempData[this.step].length - 1]
      if (lastTemp.intro.length == 0 && typeof lastTemp.image === 'string' && typeof lastTemp.voice === 'string') {
        this.$message.error('文字、图片、语音三者不能都为空')
        return
      }

      this.currentIndex = this.tempData[this.step].length

      this.tempData[this.step].push({
        sn: this.currentIndex + 1,
        intro: '',
        image: '',
        voice: ''
      })
      this.currentVoices = []
      this.currentImages = []

      // this.$refs['question'].resetFields();
    },

    editTemp(index) {
      this.currentIndex = index

      if (typeof this.tempData[this.step][this.currentIndex].image === 'object') {
        this.currentImages = [this.tempData[this.step][this.currentIndex].image]
      } else {
        this.currentImages = []
      }

      if (typeof this.tempData[this.step][this.currentIndex].voice === 'object') {
        this.currentVoices = [this.tempData[this.step][this.currentIndex].voice]
      } else {
        this.currentVoices = []
      }
      // this.currentVoices=[ this.tempData[this.step][this.currentIndex].voice];
    },
    deleteTemp(index) {
      this.tempData[this.step].splice(index, 1)
      //把序号重排
      this.tempData[this.step].map((value, index, arr) => {
        value.sn = index + 1
      })
      this.editTemp(0)
    },
    preStep() {
      this.step -= 1
      this.currentIndex = 0
    },
    nextStep() {
      //题干必须有
      console.log('next step')
      if (this.step == 0) {
        let firstTemp = this.tempData[this.step][0]

        // console.log(firstTemp.intro.length == 0 && (typeof firstTemp.image === 'string') && (typeof firstTemp.voice === 'string'));
        if (firstTemp.intro.length == 0 && typeof firstTemp.image === 'string' && typeof firstTemp.voice === 'string') {
          this.$message.error('文字、图片、语音三者不能都为空')
          return
        }

        //判断最后一条记录是否信息有效

        let lastTemp = this.tempData[0][this.tempData[0].length - 1]

        if (lastTemp.intro.length == 0 && typeof lastTemp.image === 'string' && typeof lastTemp.voice === 'string') {
          //无效信息，不添加到记录中

          this.tempData[0].splice(this.tempData[0].length - 1, 1)
        }
      }

      //选项可以没有
      //
      if (this.step == 1) {
        //判断最后一条记录是否信息有效

        let lastTemp = this.tempData[1][this.tempData[1].length - 1]

        if (lastTemp.intro.length == 0 && typeof lastTemp.image === 'string' && typeof lastTemp.voice === 'string') {
          //无效信息，不添加到记录中

          this.tempData[1].splice(this.tempData[1].length - 1, 1)
        }
      }

      if (this.step == 2) {
        //判断是否是选择题
        if (this.answerType == 0 && this.answerSelection.length == 0) {
          this.$message.error('请设置正确答案选项')
          return
        }
      }

      this.step += 1

      this.currentIndex = 0
      this.currentVoices = []
      this.currentImages = []

      let that = this

      if (this.step == 2 && this.answerSelection.length > 0) {
        setTimeout(function() {
          let answerList = []
          for (let j = 0; j < that.answerSelection.length; j++) {
            for (let i = 0; i < that.tempData[1].length; i++) {
              if (that.answerSelection[j].sn == that.tempData[1][i].sn) {
                answerList.push(that.tempData[1][i])
                break
              }
            }
          }

          // answerList.push(that.tempData[1][0]);
          answerList.forEach(row => {
            // console.log(row)
            that.$refs.multipleTable.toggleRowSelection(row, true)
          })
        }, 500)
      }
    },

    uploadImage(param) {
      let file = param.file

      var fileAV = new AV.File(file.name, file)
      fileAV
        .save()
        .then(f => {
          this.tempData[this.step][this.currentIndex].image = {
            name: file.name,
            url: f.url()
          }
        })
        .catch(alert)
    },
    removeImage(param) {
      this.tempData[this.step][this.currentIndex].image = ''
    },

    uploadVoice(param) {
      let file = param.file

      var fileAV = new AV.File(file.name, file)
      fileAV
        .save()
        .then(f => {
          this.tempData[this.step][this.currentIndex].voice = {
            name: file.name,
            url: f.url()
          }
        })
        .catch(alert)
    },
    removeVoice(param) {
      this.tempData[this.step][this.currentIndex].voice = ''
    },

    //选择题答案选项
    handleMultipleChange(val) {
      this.answerSelection = val
    },

    submitForm(formName) {
      //检查
      if (this.gradesValue.length == 0) {
        this.$message.error('请选择等级分类')
        return
      }

      if (this.questionTypesValue.length == 0) {
        this.$message.error('请选择题型分类')
        return
      }

      this.question.answerType = this.answerType
      this.question.gradeClassify = this.gradeClassify
      this.question.keywords = this.standardAnswerText.split("|")
      this.question.answerSelection = this.answerSelection
      this.question.standardAnswerText = this.standardAnswerText
      this.question.questionData = this.tempData
      this.question.tags =[]

      console.log(this.questionTypesValue)

      for (let i = 0; i < this.questionTypesAV.length; i++) {
        if (this.questionTypesAV[i].id == this.questionTypesValue) {
          this.question.questionType = this.questionTypesAV[i]
          // console.log(AV.parseJSON(this.questionTypesAV[i]))
          break
        }
      }
      for (let i = 0; i < this.tagsAV.length; i++) {
        for(let j=0;j<this.tagsValue.length;j++){
          if(this.tagsAV[i].id==this.tagsValue[j]){
            this.question.tags.push(this.tagsAV[i])
            break
          }
        }
      }
      // console.log(this.gradesValue);
      for (let i = 0; i < this.gradesAV.length; i++) {
        // question.grade.series + " - " + question.grade.name
        // console.log(this.gradesAV[i].series + ' - ' + this.gradesAV[i].name + ' - ' + this.gradesAV[i].classify )
        if (this.gradesAV[i].id == this.gradesValue) {
          this.question.grade = this.gradesAV[i]

          break
        }
      }

      // console.log(this.question)

      //保存题目

      // console.log(this.question)
      let that = this
      Object.assign(AV.Object.createWithoutData('NJQuestion', this.question.objectId), AV.parseJSON(this.question))
        .save()
        .then(question => {
          //保存新增的条件
          // localStorage.addAnyDay = that.anyDay
          // localStorage.addIndexInOneDay = that.indexInOneDay
          // localStorage.addGradesValue = that.gradesValue
          // localStorage.addQuestionTypesValue = that.questionTypesValue

          //   this.$confirm('选择操作?', '提示', {
          //     confirmButtonText: '继续新增，复用本题',
          //     cancelButtonText: '继续新增，不复用本题',
          //     type: 'warning'
          //   })
          //     .then(() => {
          //       this.$router.push({ path: '/question/add', query: { id: question.id, copy: '1' } })
          //     })
          //     .catch(() => {
          //       this.$router.push({ path: '/question/add', query: { id: question.id } })
          //     })

          this.dialogVisible = true
        })
        .catch(alert)
    },
    continueAddQuestion() {
      let that = this
      //获取最后一题信息
      // new AV.Query(Question).descending('updatedAt').first().then(question => {

      // })

      that.$router.push({ path: '/question/add' })
      that.reload()
    },
    toQuestionList() {
      this.$router.push({ path: '/question/list' })
    }
  }
}
</script>
